import { Card } from '@/components/ds'
import { Ic } from '@/components/icons'

/** Shown when VITE_SUPABASE_URL / VITE_SUPABASE_ANON_KEY are missing. */
export function SetupScreen() {
  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'grid',
        placeItems: 'center',
        padding: 24,
        background: 'var(--bg-app)',
      }}
    >
      <div style={{ width: '100%', maxWidth: 520 }}>
        <Card title="Finish the setup">
          <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
            <div style={{ display: 'flex', gap: 10, alignItems: 'flex-start' }}>
              <span style={{ color: 'var(--status-pending-fg)', marginTop: 2 }}>
                <Ic.warning size={16} />
              </span>
              <p style={{ margin: 0, fontSize: 14, color: 'var(--text-secondary)' }}>
                The app can't reach Supabase yet. Copy <code>.env.example</code> to{' '}
                <code>.env</code> and fill in your project URL and <strong>anon</strong> key, then
                restart the dev server.
              </p>
            </div>
            <pre
              style={{
                margin: 0,
                padding: 14,
                background: 'var(--surface-sunken)',
                border: '1px solid var(--border-default)',
                borderRadius: 'var(--radius-md)',
                fontFamily: 'var(--font-mono)',
                fontSize: 12,
                color: 'var(--text-primary)',
                overflowX: 'auto',
              }}
            >
              {`VITE_SUPABASE_URL=https://<project-ref>.supabase.co
VITE_SUPABASE_ANON_KEY=<anon key>`}
            </pre>
            <p style={{ margin: 0, fontSize: 12, color: 'var(--text-muted)' }}>
              The service-role key does <strong>not</strong> belong in this file — it is set as a
              Cloudflare secret for the Pages Functions and the Worker only.
            </p>
          </div>
        </Card>
      </div>
    </div>
  )
}
